import {Component, OnInit} from '@angular/core';
import {
  RealtorPortalService
} from '../../services/network/realtor-portal.service';
import {Router} from '@angular/router';
import {
  ToastSuccessComponent
} from '../../parts/toast-success/toast-success.component';
import {MatSnackBar} from '@angular/material';
import {NewEntity} from '../../models/new-entity';
import {ApiAccessService} from '../../services/network/api-access.service';
import {UtilitiesService} from '../../services/utilities.service';
import { DialogsService } from 'src/app/services/dialog.service';

enum EntityType {
  Agent = 1,
  Coordinator = 2,
  ClosingOfficer = 3,
  ClosingOfficerCoordinator = 4
}

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  isLoggedIn = false;
  displayName: string;
  emailAddress: string;
  password: string;
  emailAddressAcceptable = false;
  passwordConfirm: string;
  emailAddressUnacceptable = false;
  creatingWebUser = false;
  emailAddressTaken = false;
  emailAddressMalformed = false;


  savingPerson = false;

  selectedIndex = 0;
  agentFirstName = '';
  agentLastName = '';
  agentLicenseNumber = '';
  phoneNumber = '';
  agents: any[];
  newPerson: NewEntity = new NewEntity();

  branches: any[];
  findingAgents = false;
  agentSearchResultsVisible = false;
  branchSearchName = '';
  branchSearchCity = '';
  searchingForBranch = false;
  branchSearchResultVisible = false;
  addOfficeVisible = false;
  newBranch: NewEntity = new NewEntity();
  savingBranch = false;

  entityType: number;
  selectedParent: any;

  titleSearchResultVisible = false;
  addTitleOfficeVisible = false;
  titleNameSearch = '';
  titleCitySearch = '';
  searchingForTitleCompany = false;
  titleCompanies: any[];
  newTitleCompany: NewEntity = new NewEntity();
  savingTitleCompany = false;
  addEscrowOfficerVisible = false;

  escrowOfficerFirstNameSearch = '';
  escrowOfficerLastNameSearch = '';
  escrowOfficerSearchResultVisible = false;
  escrowOfficers: any[];
  searchingForEscrowOfficer = false;


  findingClosingOfficerCoordinator = false;
  closingOfficerCoordinator: any[];
  closingOfficerCoordinatorResultVisible = false;
  closingOfficerCoordinatorFirstName = '';
  closingOffcierCoordinatorLastName = '';

  findingRealEstateTransactionCoordinator = false;
  realEstateTransactionCoordinator: any[];
  realEstateTransactionCoordinatorResultVisible = false;



  private CREATE_USER_STEP = 6;
  FIND_BRANCH_STEP = 3;
  TITLE_COMPANY_SEARCH_STEP = 5;
  FIND_TITLE_COMPANY_SEARCH_STEP = 7;


  constructor(private realtorPortalService: RealtorPortalService,
              private dialogService: DialogsService,
              private router: Router, private snakbar: MatSnackBar) {
    this.isLoggedIn = ApiAccessService.isLoggedIn;
    if (this.isLoggedIn) {
      this.CREATE_USER_STEP = 5;
      this.FIND_BRANCH_STEP = 2;
      this.TITLE_COMPANY_SEARCH_STEP = 4;
      this.FIND_TITLE_COMPANY_SEARCH_STEP = 6;
    }
  }

  ngOnInit() {
    this.realtorPortalService.getWebUserInfo().then(sideBar=> {
      console.log(sideBar);
      this.newPerson.Name = sideBar.DisplayName;
      this.newPerson.Email = sideBar.UserId;
    });
  }

  get canCreateWebUser() {
    return this.emailAddress &&
           UtilitiesService.isEmailValid(this.emailAddress) &&
           this.emailAddressAcceptable && this.password &&
           this.password === this.passwordConfirm && this.displayName;
  }

  createWebUser() {
    this.creatingWebUser = true;

    this.realtorPortalService.saveWebUser({
                               Email: this.emailAddress,
                               Password: this.password,
                               PasswordConfirm: this.passwordConfirm,
                               DisplayName: this.displayName,
                             })
        .then(savedUser => {
          this.creatingWebUser = false;
          this.selectedIndex = 1;
          ApiAccessService.setLoginInfo(this.emailAddress, this.password);
        });
  }

  doEmailAddressCheck() {
    console.log('checking');
    this.emailAddressAcceptable = false;
    this.emailAddressUnacceptable = false;
    this.emailAddressMalformed = false;
    this.emailAddressTaken = false;
    if (this.emailAddress && UtilitiesService.isEmailValid(this.emailAddress)) {
      this.realtorPortalService.getWebUserIdExists(this.emailAddress)
          .then(exists => {
            this.emailAddressAcceptable = !exists;
            this.emailAddressUnacceptable = exists;
            this.emailAddressTaken = true;

            console.log(exists);
          });
    } else if (!UtilitiesService.isEmailValid(this.emailAddress)) {
      this.emailAddressAcceptable = false;
      this.emailAddressMalformed = true;
    }
  }

  get canSearchForAgent() {
    return this.phoneNumber 
  }

  get canSearchForBranch() {
    return this.branchSearchName && this.branchSearchCity;
  }

  get canSearchForTitleCompany() {
    return this.titleNameSearch && this.titleCitySearch;
  }

  get canSearchForEscrowOfficer() {
    return this.phoneNumber;
  }

  get canSearchForClosingOfficerCoordinator() {
    return this.phoneNumber;
  }
  get canSearchForRealEstateTransactionCoordinator() {
    return this.phoneNumber;
  }

  get canSaveBranch() {
    return this.newBranch.Name && this.newBranch.StreetAddress &&
           this.newBranch.City && this.newBranch.State &&
           this.newBranch.ZipCode && this.newBranch.Phone &&
           UtilitiesService.isValidPhoneNumber(this.newBranch.Phone);
  }

  get canSaveTitleCompany() {
    return this.newTitleCompany.Name && this.newTitleCompany.StreetAddress &&
           this.newTitleCompany.City && this.newTitleCompany.State &&
           this.newTitleCompany.ZipCode && this.newTitleCompany.Phone &&
           UtilitiesService.isValidPhoneNumber(this.newTitleCompany.Phone);
  }

  get canSavePerson() {
    return this.newPerson.Name && this.newPerson.StreetAddress &&
           this.newPerson.City && this.newPerson.State &&
           this.newPerson.ZipCode && this.newPerson.Phone &&
           this.newPerson.Email &&
           UtilitiesService.isEmailValid(this.newPerson.Email);
  }

  get canGoToSecondStep() { return this.entityType > 0; }

  searchForAgent() {
    this.findingAgents = true;
    this.realtorPortalService.findAgentByName(this.agentFirstName,
                                              this.agentLastName,
                                              this.agentLicenseNumber)
        .then(agents => {

          this.findingAgents = false;
          this.agents = agents;
          this.agentSearchResultsVisible = true;
        });
  }
  searchForAgentByPhone() {
    this.findingAgents = true;
    this.realtorPortalService.findAgentByPhone(this.phoneNumber)
      .then(agents => {

        this.findingAgents = false;
        this.agents = agents;
        this.agentSearchResultsVisible = true;
      });
  }
  goToSecondStep() {
    let index = 0;
    if (this.entityType === EntityType.Agent) {
      index = 2;
    } else if (this.entityType === EntityType.Coordinator) {
      index = 8;
    } else if (this.entityType === EntityType.ClosingOfficerCoordinator) {
      index = 5;
    } else if (this.entityType === EntityType.ClosingOfficer) {
      index = 4;
    }

    if (this.isLoggedIn) {
      index--;
    }

    this.selectedIndex = index;
  }

  searchForBranch() {
    this.searchingForBranch = true;
    this.realtorPortalService.findBranchByNameAndCity(this.branchSearchName,
                                                      this.branchSearchCity)
        .then(branches => {
          this.searchingForBranch = false;
          this.branches = branches;
          this.branchSearchResultVisible = true;
        });
  }

  saveNewBranch() {
    this.savingBranch = true;
    this.realtorPortalService.saveNewBranch(this.newBranch)
        .then(result => {
          this.setRealEstateBranch(this.newBranch);
          this.savingBranch = false;
        });
  }

  saveNewTitleCompany() {
    this.savingTitleCompany = true;
    this.realtorPortalService.saveNewTitleCompany(this.newTitleCompany)
        .then(result => {
          this.setRealEstateBranch(this.newTitleCompany);
          this.savingTitleCompany = false;
        });
  }

  savePerson() {
    this.savingPerson = true;
    this.newPerson.ParentId = this.selectedParent.Id;

    if (this.entityType === EntityType.Agent) {
      this.realtorPortalService.saveAgent(this.newPerson)
        .then((result) => {
          if (result == false) {
            this.dialogService.alert('Existing Agent', 'An agent already exists with the same license number.');
          }
            this.setAgent(this.newPerson);
            this.savingPerson = false;
          });
    } else if (this.entityType === EntityType.Coordinator) {
      this.realtorPortalService.saveCoordinator(this.newPerson)
          .then(() => {
            this.setAgent(this.newPerson);
            this.savingPerson = false;
          });
    } else if (this.entityType === EntityType.ClosingOfficer) {
      this.realtorPortalService.saveClosingOfficer(this.newPerson)
          .then(() => {
            this.setAgent(this.newPerson);
            this.savingPerson = false;
          });
    } else if (this.entityType === EntityType.ClosingOfficerCoordinator) {
      this.realtorPortalService.saveClosingOfficerCoordinator(this.newPerson)
          .then(() => {
            this.setAgent(this.newPerson);
            this.savingPerson = false;
          });
    }
  }

  searchForEscrowOfficer() {
    this.searchingForEscrowOfficer = true;
    this.realtorPortalService.findEscrowOfficerByName(
                                 this.escrowOfficerFirstNameSearch,
                                 this.escrowOfficerLastNameSearch)
        .then(escrowOfficers => {
          this.searchingForEscrowOfficer = false;
          this.escrowOfficers = escrowOfficers;
          this.escrowOfficerSearchResultVisible = true;
        });
  }

  searchForEscrowOfficerByPhone() {
    this.searchingForEscrowOfficer = true;
    this.realtorPortalService.findEscrowOfficerByPhone(this.phoneNumber)
      .then(escrowOfficers => {
        this.searchingForEscrowOfficer = false;
        this.escrowOfficers = escrowOfficers;
        this.escrowOfficerSearchResultVisible = true;
      });
  }

  searchForClosingOfficerCoordinator() {
    this.findingClosingOfficerCoordinator = true;
    this.realtorPortalService.findClosingOfficerCoordinatorByPhone(this.phoneNumber)
      .then(closingOfficerCoordinator => {
        this.findingClosingOfficerCoordinator = false;
        this.closingOfficerCoordinator = closingOfficerCoordinator;
        this.closingOfficerCoordinatorResultVisible = true;

      });
  }

  searchForRealEstateTransactionCoordinator() {
    this.findingRealEstateTransactionCoordinator = true;
    this.realtorPortalService.findRealEstateTransactionCoordinatorByPhone(this.phoneNumber)
      .then(realEstateTransactionCoordinator => {
        this.findingRealEstateTransactionCoordinator = false;
        this.realEstateTransactionCoordinator = realEstateTransactionCoordinator;
        this.realEstateTransactionCoordinatorResultVisible = true;
      });
  }

  searchForTitleCompany() {
    this.searchingForTitleCompany = true;
    this.realtorPortalService.findTitleCompanyByNameAndCity(
                                 this.titleNameSearch, this.titleCitySearch)
        .then(titleCompanies => {
          this.searchingForTitleCompany = false;
          this.titleCompanies = titleCompanies;
          this.titleSearchResultVisible = true;
        });
  }

  setTitleCompany(titleCompany) {
    this.selectedParent = titleCompany;
    this.selectedIndex = this.CREATE_USER_STEP;
  }

  setRealEstateBranch(realEstateBranch) {
    this.selectedParent = realEstateBranch;
    this.selectedIndex = this.CREATE_USER_STEP;
  }

  escrowOfficer(escrowOfficer) { throw 'TODO: implement this'; }

  setAgent(agent) {
    this.realtorPortalService.attachEntityToWebUser(agent.Id)
        .then(() => { this.completeRegistration(); });
  }

  setClosingOfficerCoordinator(closingOfficerCoordinator) {
    this.realtorPortalService.attachEntityToWebUser(closingOfficerCoordinator.Id)
      .then(() => { this.completeRegistration(); })
  }

  private completeRegistration() {
    this.snakbar.openFromComponent(ToastSuccessComponent, {
      data: 'Your real estate information has been successfully attached.',
      duration: 10000,
      panelClass: ['success-toast']
    });
    this.router.navigateByUrl('/home');
    //Clear the cached side-bar info
    this.realtorPortalService.getSideBarInfo(true).then(()=> {});
  }
}
